import Api from '@/services/Api'

export default {
  upload (image, onUploadProgress) {
    return Api().post('images', image, onUploadProgress)
  }
}



// WEBPACK FOOTER //
// ./src/services/ImagesService.js